export const doGetSites = async () => {
  try {
    const response = await fetch("/sites", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    // 1. Verifica se la risposta � JSON prima di analizzarla
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const errorText = await response.text();
      console.error("Risposta non JSON ricevuta:", errorText);
      return {
        success: false,
        function: "doGetSites",
        stack: `Errore HTTP ${response.status}: L'endpoint /sites ha restituito HTML anzich� JSON. Verifica che il server Node sia in esecuzione.`,
      };
    }

    // 2. Parsifica il JSON in sicurezza
    const data = await response.json();

    if (response.ok) {
      return {
        success: true,
        sites: Array.isArray(data) ? data : data.sites || [],
      };
    } else {
      return {
        success: false,
        function: "doGetSites",
        stack: data.error || data.message || "Errore durante il recupero dei siti",
      };
    }
  } catch (error) {
    return {
      success: false,
      function: "doGetSites",
      stack: error.message,
    };
  }
};